/* eslint-disable sonarjs/no-identical-functions */
// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';

const styles = css`
  &.promo-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    ${(props) =>
      props.isNewPJPPDPRedesignEnabled && props.className === 'isPDP'
        ? `box-sizing: border-box;
        width: 100%;`
        : null}

    ${(props) =>
      !props.isNewPJPPDPRedesignEnabled && props.className === 'isPDP' ? `width: 82%;` : null}

    ${(props) =>
      props.className !== 'isPDP' && props.isTileRedesignAB
        ? `width: fit-content;
          padding: 6px 2px;
          gap: 4px;
          margin-top: 2px;
          @media ${props.theme.mediaQuery.smallOnly} {
            max-width: calc(100% - 34px);
          }
          max-width: calc(100% - 44px);
          `
        : null}

    ${(props) =>
      props.className === 'isPDP'
        ? `border-radius: ${props.theme.spacing.ELEM_SPACING.XS_6};`
        : ` border-radius: ${
            props.isTileRedesignAB ? '0px' : props.theme.spacing.ELEM_SPACING.XS_6
          };`}
    background: ${(props) => {
      return props.theme.colors.PRIMARY.COLOR4;
    }};
    height: auto;
    ${(props) =>
      props.className !== 'isPDP' && !props.isTileRedesignAB
        ? `width: '91%';
      `
        : null}
  }

  .promo-ab {
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy2}px;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy1}px;
    }
    line-height: 14px;
    font-weight: 500;
    color: ${(props) => props.theme.colors.BLACK};
    cursor: pointer;
  }
  &.promotion-applied-container {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .promo-list-head {
    display: flex;

    ${(props) =>
      props.className === 'isPDP'
        ? ` flex-direction: column; align-items: flex-start;`
        : ` align-items: center;`}
  }
  .promo-list-item {
    display: flex;
    align-items: flex-start;
    ${(props) => (props.pageName === 'PDP' ? `padding: 4px 8px;` : ``)}
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
  }
  .promo-list-item-margin-top {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  }
  .arrow {
    display: flex;
    align-items: center;
  }
  .promo_message_anchor {
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    display: flex;
    text-align: left;
    align-items: center;
    font-size: ${(props) =>
      props.className === 'isPLP'
        ? `${props.theme.fonts.fontSize.body.bodytext.copy2}px`
        : `${props.theme.fonts.fontSize.body.bodytext.copy3}px`};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) =>
        props.className === 'isPLP'
          ? `${props.theme.fonts.fontSize.body.bodytext.copy1}px`
          : `${props.theme.fonts.fontSize.body.bodytext.copy3}px`};
    }

    color: ${(props) => props.theme.colors.BLACK};
    cursor: pointer;
  }
  .underLine {
    text-decoration: underline;
    text-underline-offset: 3px;
  }
  .icon_invisible {
    visibility: hidden;
  }
  .icon_visible {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    visibility: visible;
  }
  .icon {
    margin-right: ${(props) =>
      props.className === 'isPDP'
        ? props.theme.spacing.ELEM_SPACING.SM
        : props.theme.spacing.ELEM_SPACING.XS};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
      margin-right: ${(props) =>
        props.className === 'isPDP'
          ? props.theme.spacing.ELEM_SPACING.XS_1
          : props.theme.spacing.ELEM_SPACING.XXS};
    }
  }
  .icon_margin_right {
    margin-right: ${(props) =>
      props.className === 'isPDP'
        ? props.theme.spacing.ELEM_SPACING.SM
        : props.theme.spacing.ELEM_SPACING.XS};
  }
  .icon-promotion-applied {
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    }
  }
  .promo_heading {
    font-weight: 800;
  }
  .best-offers {
    color: #000000;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 14px;
    }
  }

  &.pdp-redesign-promo-wrapper.promo-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    background: unset;

    .pdp-redesign-promo {
      padding: 4px 8px;
      border-radius: 6px;
      background: #fee800;
      margin: 0;
      width: 100%;
      box-sizing: border-box;
    }

    .promo-content-wrapper {
      display: flex;
      align-items: center;
    }

    .promo_price {
      color: #c8102e;
      text-align: center;
      font-family: Nunito;
      font-size: 20px;
      font-style: normal;
      font-weight: 800;
      line-height: normal;
      margin-right: 8px;
      white-space: nowrap;
    }

    .promo_message {
      color: #1a1a1a;
      font-family: Nunito;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: 14px;

      @media ${(props) => props.theme.mediaQuery.large} {
        font-size: 14px;
      }
    }
  }

  .pickup-store-modal-promotions {
    font-size: 14px !important;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 12px !important;
    }
  }
`;

export const PromoContainer = styled.div`
  ${(props) => (props.isPdp ? ' margin-top: 8px' : '')};
  ${(props) => (props.isApplyCheckboxPromoOnPdp ? 'width: 100%' : '')};
  ${(props) => (props.isApplyCheckboxPromoOnPdp ? 'display: flex;' : '')};
  ${(props) => (props.isApplyCheckboxPromoOnPdp ? 'flex-direction: column' : '')};
  ${(props) => (props.isApplyCheckboxPromoOnPdp ? 'row-gap: 8px' : '')};
`;

export default styles;
